<div class="rectangle">
  <div class="dialog-heading mb-4">
    <div class="content">
      <span class="search-sites">
        {{ 'Search Sites' | translate }}
      </span>
      <img src="../../../../assets/images/close.png" class="close" (click)="close()">
    </div>
  </div>
  <div class="search-list">
    <div class="search">
      <input class="search-user" [placeholder]="'Search (User, Eps)' | translate" [(ngModel)]="searchText" (keyup)="search()">
      <button class="search-icon"><i class="fa fa-search app-color-1" (click)="closeAndFlush()"></i></button>
    </div>
    @for (item of searchResults | keyvalue; track trackByIndex($index)) {
      <div class="p-2">
        <div class="search-header-block">
          <i [ngClass]="searchIcons[item.key]"> </i> <b class="pl-2">{{item.key}}</b>
        </div>
        @for (me of item.value; track trackById($index, me)) {
          <div>
            <p class="pl-3 link-cursor" (click)="selectAndFlush(me)">
              {{me.name}}
            </p>
          </div>
        }
      </div>
    }
  </div>

  @if (searchText && searchResultsCount == 0 && !loading) {
    <div class="createButton pt-3">
      <button class="btn btn-primary" (click)="createNewEndPoint()">{{ 'Create New Endpoint' | translate }}</button>
    </div>
  }
</div>
